<div class="app-dialog dc-share">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ "digitalCards.sources.createModalTitle" | translate }}</h2>
    </div>
    <button
      type="button"
      mat-icon-button
      (click)="close()"
      [attr.aria-label]="'digitalCard.owner.closeModal' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <section class="app-dialog__section">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="dc-create-field">
        <mat-label>{{ "digitalCards.sources.nameLabel" | translate }}</mat-label>
        <input
          matInput
          [formControl]="nameControl"
          maxlength="100"
          (keydown.enter)="submit()"
          [disabled]="creating"
        />
      </mat-form-field>
      @if (errorKey) {
        <p class="dc-create-error">{{ errorKey | translate }}</p>
      }
    </section>
  </div>

  <footer class="app-dialog__footer">
    <button type="button" mat-stroked-button (click)="close()" [disabled]="creating">
      {{ "cancel" | translate }}
    </button>
    <button
      type="button"
      mat-flat-button
      color="primary"
      (click)="submit()"
      [disabled]="!canSubmit"
    >
      {{ "digitalCards.sources.create" | translate }}
    </button>
  </footer>
</div>
